import { Controller } from "@hotwired/stimulus"

// Тикающий секундомер: показывает время с startedAt, пока running.
// Сервер хранит только момент старта, поэтому считаем от него, а не от загрузки страницы.
export default class extends Controller {
  static targets = ["display"]
  static values = { startedAt: String, running: Boolean }

  connect() {
    if (!this.runningValue || !this.startedAtValue) return

    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    const seconds = Math.max(0, Math.floor((Date.now() - Date.parse(this.startedAtValue)) / 1000))
    const pad = (n) => String(n).padStart(2, "0")
    const h = Math.floor(seconds / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = seconds % 60
    this.displayTarget.textContent = h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`
  }
}
